import styled from "styled-components"

export const ButtonSee = styled.button`
background-color: #44CCA6;
border: none;
border-radius: 24px;
color: #fff;
cursor: pointer;
font-size: 14px;
height: 37px;
line-height: 18.9px;   
width: 120px;

`